module.exports = __webpack_public_path__ + "img/stop.1ecd0dc1.svg";